export const dateRangeFields = {
  CreatedDate: 'createdDate',
  DueDate: 'dueDate',
  DowntimeStartDate: 'downtimeStart',
  DowntimeEndDate: 'downtimeEnd',
  CompletionDate: 'completionDate',
}
